import graphql from "babel-plugin-relay/macro";

export const QUERY = graphql`
	query moduleRatings_Query($first: Int, $after: String, $value: BigDecimalRangeFilter) {
		...moduleRatingsTable_RefetchableQueryFragment
			@arguments(first: $first, after: $after, value: $value)
	}
`;
